/**
 * Created by huion on tap 2017/6/28.
 */


$(function () {
    var $window = $(window),
        win_height_padded = $window.height() * 1.0,
        isTouch = Modernizr.touch;

    if (isTouch) {
        $('.revealOnScroll').addClass('animated');
    }

    $window.on('scroll', revealOnScroll);

    function revealOnScroll() {
        var scrolled = $window.scrollTop(),
            win_height_padded = $window.height() * 1.0;

        // Showed...
        $(".revealOnScroll:not(.animated)").each(function () {
            var $this = $(this),
                offsetTop = $this.offset().top;

            if (scrolled + win_height_padded > offsetTop) {
                if ($this.data('timeout')) {
                    window.setTimeout(function () {
                        $this.addClass('animated ' + $this.data('animation'));
                    }, parseInt($this.data('timeout'), 10));
                } else {
                    $this.addClass('animated ' + $this.data('animation'));
                }
            }
        });
        // Hidden...
//      $(".revealOnScroll.animated").each(function (index) {
//          var $this = $(this),
//              offsetTop = $this.offset().top;
//          if (scrolled + win_height_padded < offsetTop) {
//              $(this).removeClass('animated fadeInUp fadeInUpDl fadeInUpD7 fadeInUpD9 fadeInUpL100 fadeInLeftL50 fadeInRightL50 fadeInUpL250')
//          }
//      });
    }
    revealOnScroll();
});